import { render, staticRenderFns } from "./mensajes.vue?vue&type=template&id=bb096f38&scoped=true&"
import script from "./mensajes.vue?vue&type=script&lang=ts&"
export * from "./mensajes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb096f38",
  null
  
)

export default component.exports